import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { TenantDetail } from "./components/TenantDetail";
import { TenantsContainer } from "./components/tenants.container";

function TenantDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.admin.tenants.detail);
  const navigate = useNavigate();
  return <TenantDetail id={id} onBack={() => navigate("..")} />;
}

export function TenantsRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<TenantsContainer />} />
        <Route path=":id" element={<TenantDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
